import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useTheme} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {useRecoilValue} from "recoil";
import {useFormContext} from "react-hook-form";
import {FormCheckbox, FormTextField} from "../../../common/form-fields-wrappers";
import {ICounterSale, IRaFillingForm} from "../../../models/models";
import {counterSaleManagementValueState} from "../../state";

const QuotationInfo = () => {
	const {t} = useTranslation(['network', 'translation']);
	const theme = useTheme();
	const counterSaleManagement = useRecoilValue<{previous: ICounterSale, last: ICounterSale}>(counterSaleManagementValueState);
	const raFillingDataForm = useFormContext<IRaFillingForm>();

	return (
		<>
			<Accordion >
				<AccordionSummary expandIcon={<ExpandMore />}>
					<Typography variant={"h6"}>
						{t("raFilling.quotationInfo.accordion.title")}
					</Typography>
				</AccordionSummary>

				<AccordionDetails>
					<Grid container columnSpacing={4}>
						<Grid item container xs={12} md={6} columnSpacing={2}>
							<Grid item xs={12}>
								<Typography variant={"bodyLarge"}>
									{t("raFilling.quotationInfo.accordion.subtitle.quotation")}
								</Typography>
							</Grid>

							<Grid item xs={6}>
								<FormTextField<IRaFillingForm>
									name={'quotationInfo.rate'}
									label={t("raFilling.quotationInfo.form.label.rate")}
									control={raFillingDataForm.control}
									disabled
								/>
							</Grid>

							<Grid item xs={6} sx={{display: "flex", alignItems: "center"}}>
								<FormCheckbox<IRaFillingForm>
									name={`quotationInfo.reservedTariffs`}
									label={t("raFilling.quotationInfo.form.label.reservedTariffs")}
									color={'primary'}
									disabled
									sx={{color: theme.palette.primary.main}}
								/>
							</Grid>

							<Grid item xs={6}>
								<FormTextField<IRaFillingForm>
									name={'quotationInfo.rentalAmount'}
									label={t("raFilling.quotationInfo.form.label.rentalAmount")}
									control={raFillingDataForm.control}
									disabled
								/>
							</Grid>
							<Grid item xs={6}>
								<FormTextField<IRaFillingForm>
									name={'quotationInfo.totalAncilliariesAmount'}
									label={t("raFilling.quotationInfo.form.label.totalAncilliariesAmount")}
									control={raFillingDataForm.control}
									disabled
								/>
							</Grid>

							{null !== raFillingDataForm.getValues('quotationInfo.roadTax') && '' !== raFillingDataForm.getValues('quotationInfo.roadTax') &&
								<Grid item xs={6}>
									<FormTextField  name={'quotationInfo.roadTax'}
													label={t("raFilling.quotationInfo.form.label.roadTax")}
													disabled
									/>
								</Grid>
							}

							{null !== raFillingDataForm.getValues('quotationInfo.airportTax') && '' !== raFillingDataForm.getValues('quotationInfo.airportTax') &&
								<Grid item xs={6}>
									<FormTextField  name={'quotationInfo.airportTax'}
													label={t("raFilling.quotationInfo.form.label.airportTax")}
													disabled
									/>
								</Grid>
							}

							{null !== raFillingDataForm.getValues('quotationInfo.railwayTax') && '' !== raFillingDataForm.getValues('quotationInfo.railwayTax') &&
								<Grid item xs={6}>
									<FormTextField  name={'quotationInfo.railwayTax'}
													label={t("raFilling.quotationInfo.form.label.railwayTax")}
													disabled
									/>
								</Grid>
							}

							<Grid item xs={6}>
								<FormTextField<IRaFillingForm>
									name={'quotationInfo.totalRentalAmountVatExcl'}
									label={t("raFilling.quotationInfo.form.label.totalRentalAmountVatExcl")}
									control={raFillingDataForm.control}
									disabled
								/>
							</Grid>

							{
								counterSaleManagement?.last?.promoRentalAmountVatIncludedTotal !== null &&
								counterSaleManagement?.last?.promoRentalAmountVatIncludedTotal !== undefined &&
								counterSaleManagement?.last?.promoRentalAmountVatIncludedTotal !== 0 &&
								<Grid item xs={6}>
									<FormTextField<IRaFillingForm>
										name={'quotationInfo.deltaDiscounts'}
										label={t("raFilling.quotationInfo.form.label.discountsApplied")}
										control={raFillingDataForm.control}
										disabled
									/>
								</Grid>
							}

							<Grid item xs={6}>
								<FormTextField<IRaFillingForm>
									name={'quotationInfo.totalRentalAmountVatIncl'}
									label={t("raFilling.quotationInfo.form.label.totalRentalAmountVatIncl")}
									control={raFillingDataForm.control}
									disabled
								/>
							</Grid>

							{/*<Grid item xs={12} sx={{my: theme.spacing(2)}}>*/}
							{/*	<Box sx={{border: '1px solid',*/}
							{/*		borderColor: '#c0c1c4',*/}
							{/*		borderRadius: 2,*/}
							{/*		px: theme.spacing(1),*/}
							{/*		pb: theme.spacing(1),*/}
							{/*	}}>*/}
							{/*		<Typography variant="body1">*/}
							{/*			{t("raFilling.quotationInfo.form.label.appliedDiscounts")}*/}
							{/*		</Typography>*/}
							{/*		<Typography variant="body2">*/}
							{/*			{t("raFilling.quotationInfo.form.label.discountX")} 40,51€*/}
							{/*		</Typography>*/}
							{/*		<Typography variant="body2">*/}
							{/*			{t("raFilling.quotationInfo.form.label.discountY")} 40,00€*/}
							{/*		</Typography>*/}
							{/*	</Box>*/}

							{/*</Grid>*/}

							{/*<Grid item xs={12}>
								<FormTextField<IRaFillingForm>
									name={'quotationInfo.netRentalAmount'}
									label={t("raFilling.quotationInfo.form.label.netRentalAmount")}
									control={raFillingDataForm.control}
									disabled
								/>
							</Grid>
							*/}
						</Grid>

						<Grid item container xs={12} md={6} sx={{mb: 'auto'}} columnSpacing={2}>
							<Grid item xs={12}>
								<Typography variant={"bodyLarge"}>
									{t("raFilling.quotationInfo.accordion.subtitle.additional")}
								</Typography>
							</Grid>

							<Grid item xs={6}>
								<FormTextField<IRaFillingForm>
									name={'quotationInfo.damageExcess'}
									label={t("raFilling.quotationInfo.form.label.damageExcess")}
									control={raFillingDataForm.control}
									disabled
								/>
							</Grid>
							<Grid item xs={6}>
								<FormTextField<IRaFillingForm>
									name={'quotationInfo.fireTheftExcess'}
									label={t("raFilling.quotationInfo.form.label.fireTheftExcess")}
									control={raFillingDataForm.control}
									disabled
								/>
							</Grid>

							{/*<Grid item xs={6} sx={{height: '56px', display: "flex", alignItems: "flex-end"}}>*/}
							{/*	<Link href="#">{t("raFilling.quotationInfo.form.label.invoices")}</Link>*/}
							{/*</Grid>*/}
						</Grid>
					</Grid>

				</AccordionDetails>
			</Accordion>
		</>
	)
}

export default QuotationInfo;
